module.exports = __webpack_public_path__ + "static/mess-6e20351a0c8b609d6a2c0327210bf4ca.png";